import React from 'react';
import image1 from '../assets/images/image1.png';
import commaImg from '../assets/images/inverted_comma.svg';
import { MyButton } from './ui/MyButton.js';
import { useNavigate } from "react-router-dom";

const AboutUs = () => {
    const navigate = useNavigate();

    return (
        <div className='sizedbox py-5 text-center'>
            <h2 style={{ color: "var(--text-color)" }}>
                <span
                    style={{
                        background: "var(--primary-gradient-100)",
                        backgroundClip: "text",
                        WebkitTextFillColor: "transparent"
                    }}>
                    About
                </span>&nbsp;US
            </h2>

            <p
                style={{
                    fontSize: "18px",
                    fontWeight: "400",
                    color: "var(--text-color)",
                    lineHeight: "24px"
                }}>
                Your Trusted Library Technology Infrastructure Partner
            </p>

            <div className='mt-5 row g-2 gap-5 mb-5'>

                {/* Left Section */}
                <div className='col-12 col-md-5 text-start'>
                    <img
                        src={image1}
                        alt='Libcloud library technology infrastructure'
                        style={{
                            width: "100%",
                            objectFit: "cover",
                            borderRadius: "30px",
                            height: "auto"
                        }}
                    />

                </div>

                {/* Right Section */}
                <div className='col-12 col-md-5 text-start'>

                    <h3
                        style={{
                            color: "var(--text-color)",
                            fontSize: "24px",
                            fontWeight: "500",
                            lineHeight: "30px",
                            marginTop: "1rem"
                        }}>
                        Libcloud
                    </h3>

                    <p
                        style={{
                            color: "var(--text-color)",
                            fontSize: "18px",
                            fontWeight: "400",
                            lineHeight: "28px",
                            marginTop: "0.5rem"
                        }}>
                        Libcloud provides cloud-based SaaS and infrastructure
                        solutions for Koha Library Management System and its
                        mobile application.
                    </p>

                    <p
                        style={{
                            color: "var(--text-color)",
                            fontSize: "18px",
                            fontWeight: "400",
                            lineHeight: "28px",
                            marginTop: "1rem"
                        }}>
                        Our pre-configured, ready-to-deploy Koha platform is
                        hosted on managed cloud infrastructure, providing a
                        cost-effective and scalable alternative to building
                        and maintaining your own IT environment.
                    </p>

                    <p
                        style={{
                            color: "var(--text-color)",
                            fontSize: "18px",
                            fontWeight: "400",
                            lineHeight: "28px",
                            marginTop: "1rem"
                        }}>
                        With Android and iOS mobile applications and
                        white-label business solutions, Libcloud enables
                        business associates to offer professional library
                        technology services under their own brand.
                    </p>

                    <div className='mt-4'>
                        <MyButton
                            btntext="Contact Us"
                            onClick={() => {
                                navigate("/contact");
                            }}
                        />
                    </div>

                </div>
            </div>
        </div>
    );
};

export default AboutUs;
